module.exports = __webpack_public_path__ + "img/zixun.65a095fa.png";